import React, { Fragment, useEffect } from 'react';

import classNames from 'classnames';

import classes from './CountdownTimer.module.scss';
import { TimeUnit } from './TimeUnit/TimeUnit';
import { useTimer } from '../../../hooks/useTimer';

type TimeUnitKey = 'days' | 'hours' | 'minutes' | 'seconds';

const allTimeUnits: TimeUnitKey[] = ['days', 'hours', 'minutes', 'seconds'];

type CountdownTimerProps = {
  /** epoch in seconds */
  expirationEpoch: number;
  /** which units to show, in order */
  units?: TimeUnitKey[];
  onTimeOver?: () => void;
  className?: string;
};

const CountdownTimer = ({
  expirationEpoch,
  units = allTimeUnits,
  onTimeOver = () => {},
  className,
}: CountdownTimerProps) => {
  const timeLeft = useTimer(expirationEpoch);

  useEffect(() => {
    if (timeLeft.isTimeOver) {
      onTimeOver();
    }
  }, [timeLeft.isTimeOver]);

  return (
    <div className={classNames(classes.timer, className)}>
      {units.map((unit, index) => (
        <Fragment key={unit}>
          {index > 0 && <span className={classes.separator}>:</span>}
          <TimeUnit value={timeLeft[unit]} label={unit} />
        </Fragment>
      ))}
    </div>
  );
};

export { CountdownTimer, CountdownTimerProps };
